import { render, staticRenderFns } from "./MemberAvatars.vue?vue&type=template&id=02fc6304&scoped=true&"
import script from "./MemberAvatars.vue?vue&type=script&lang=js&"
export * from "./MemberAvatars.vue?vue&type=script&lang=js&"
import style0 from "./MemberAvatars.vue?vue&type=style&index=0&id=02fc6304&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc6304",
  null
  
)

export default component.exports